export default "__VITE_ASSET__DFGjw7k$__"